import alarmHistory from './rest/alarm-history'
import dataset from './rest/dataset'
import facility from './rest/facility'
import industryType from './rest/industry-type'
import lastestStatus from './rest/lastest-status'
import login from './rest/login'
import operatingHistory from './rest/operating-history'
import operatingSummary from './rest/operating-summary'
import organization from './rest/organization'
import plant from './rest/plant'
import prefectures from './rest/prefectures'
import site from './rest/site'
import mbrTechnicalReport from './rest/mbr-technical-report'
import technicalReport from './rest/technical-report'
import maintenanceHistory from './rest/maintenance-history'
import fieldSettings from './rest/field-settings'
import user from './rest/user'
import pfArea from './rest/pf-area'
import roTechnicalReport from './rest/ro-technical-report'
import myDashboardSetting from './rest/my-dashboard-setting'
import csvDownLoad from './rest/csv-download'
import calculationSettingsMbr from './rest/calculation_settings_mbr'
import calculationSettingsRo from './rest/calculation_settings_ro'
import calculationSettingsSaiforce from './rest/calculation_settings_saiforce'
import resampledDatasets from './rest/resampled-datasets'

export const handlers = [
  ...alarmHistory,
  ...dataset,
  ...facility,
  ...industryType,
  ...lastestStatus,
  ...login,
  ...operatingHistory,
  ...operatingSummary,
  ...organization,
  ...plant,
  ...prefectures,
  ...site,
  ...mbrTechnicalReport,
  ...technicalReport,
  ...maintenanceHistory,
  ...fieldSettings,
  ...user,
  ...pfArea,
  ...roTechnicalReport,
  ...myDashboardSetting,
  ...csvDownLoad,
  ...calculationSettingsMbr,
  ...calculationSettingsRo,
  ...calculationSettingsSaiforce,
  ...resampledDatasets,
]
